import { useEffect, useRef, useState } from 'react';
import React from 'react';
import { toast } from 'react-toastify';

import { useTranslation } from 'react-i18next';
import { deleteCertification, getAllCertifications, uploadFile } from '../../services/certifications';
import { FiFile } from 'react-icons/fi';
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';
import { Breadcrumb, BreadcrumbItem, Button, Form, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip } from 'reactstrap';
import './certifications.css';
interface Certification {
    id: number;
    name: string;
    issuer: string;
    date: string;
}

interface ListCertificationsProps {
    certifications: Certification[];
}




export default function CertificationsList() {
    const [certifications, setCertifications] = useState<Certification[]>([]);
    const [pageNo, setPageNo] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const perPage = 9;
    const {t}=useTranslation();

    const [showModal, setShowModal] = useState(false);
    const [nameCertification, setNameCertification] = useState('');
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [date, setDate] = useState('');
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedCertification, setSelectedCertification] = useState<Certification | null>(null);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
       setNameCertification(e.target.value)
    };

    const handleSubmit = async () => {
        try {
            if (uploadedFile) {
                let formData = new FormData();
                formData.append('files', uploadedFile);
                formData.append('name', nameCertification);
                const response = await uploadFile(formData);
                const responseData = await response.json();
                if (response.ok) {
                    toast.success(responseData.message);
                } else {
                    toast.error(responseData.message);
                }
            } else {
                toast.error("Please upload a file.");
            }
            
            setNameCertification("");
            setUploadedFile(null);
            handleClose();
            getCertifications();
        } catch (error: any) {
            toast.error("Error creating certification:", error);
        }
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            
            setUploadedFile(files[0]);
        }
    };

    const getCertifications = async () => {
        try {
            const response :any= await getAllCertifications('', perPage, pageNo);

            if(response.success){
                setCertifications(response.data);
                setTotalPages(response.totalPages); 
            }
            else{
                toast.error(response.message);
                console.error('Error fetching certifications:', response.message);
            }
        } catch (error) {
            toast.error('Error fetching certifications');
            console.error('Error fetching certifications:', error);
        }
    }

    useEffect(() => {
       getCertifications()
    }, []);
   
    const handleImageClick = (imageSrc: string) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const handleSignatureSubmit = () => {
        if (canvasRef.current) {
            const dataUrl = canvasRef.current.toDataURL();
            console.log('Signature Data URL:', dataUrl);
            console.log('Date:', date);
            setShowModal(false);
        }
    };

    const handleDelete = (id: number) => {
        setSelectedCertification(certifications.find(cert => cert.id === id) || null);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (selectedCertification) {
            //console.log(`Confirmed delete for certification with id: ${selectedCertification.id}`);
    try{
    const response = await deleteCertification(selectedCertification.id);
    if(response.success){
        toast.success(response.message);
        getCertifications();
            }
            else{
            toast.error(response.message);
            }
    }catch(error:any){
            toast.error(error.message);
    }
            
            // Implement actual delete logic here
            setShowDeleteModal(false);
        }
    };

    const handleUpdate = (id: number) => {
        setSelectedCertification(certifications.find(cert => cert.id === id) || null);
        setShowUpdateModal(true);
    };

    const confirmUpdate = async () => {
        if (selectedCertification) {
          try {
            let formData = new FormData();
      
            // Append the ID of the certification to be updated
            formData.append('id', selectedCertification.id.toString());
      
            // Append updated name only if provided
            if (nameCertification && nameCertification !== selectedCertification.name) {
              formData.append('name', nameCertification);
            } else {
              formData.append('name', selectedCertification.name); // Send existing name if not updated
            }
      
            // Append file only if a new file is uploaded
            if (uploadedFile) {
              formData.append('files', uploadedFile);
            }
      
            const response = await uploadFile(formData);
            const responseData = await response.json();
      
            if (response.ok) {
              toast.success(responseData.message);
            } else {
              toast.error(responseData.message);
            }
      
            // Clear form fields after update
            setNameCertification("");
            setUploadedFile(null);
            setShowUpdateModal(false);
            getCertifications();
          } catch (error: any) {
            toast.error("Error updating certification:", error.message);
          }
        }
      };
      

    return (
        <div className="root">

            <div className="d-flex justify-content-between align-items-center mb-lg">
        <h5 className="mb-lg">{t("Certifications.page_title_certifications")}</h5>
        <div>
         <button className="submit-button mr-2" onClick={handleShow}>
          <b><FaPlus className="mr-2 font-weight-bold" size={16}/>  {t("Certifications.add_certification")}</b>
          </button>
         
        </div>
      </div>

            <div className="container_info rounded-lg " style={{ padding: '40px 20px', backgroundColor: 'var(--widget-bg)' }}>
                <div className="container">
                    {certifications.length > 0 ? <div className="row">
                       

                        {certifications.map((card:any) => (
                            <div className="col-lg-4 col-md-12 mb-4" key={card.id}>
                                <div className="card card-margin" style={{ marginBottom: '20px' }}>
                                    <div className="card-header no-border d-flex justify-content-between align-items-center">
                                        <h5 className="card-title">{card.name}</h5>
                                        <div>
                                            <FaEdit
                                                className="mr-2 cursor-pointer"
                                                size={16}
                                                onClick={() => handleUpdate(card.id)}
                                                style={{color:'orange',marginRight:'5px'}}
                                                title="Edit"
                                            />
                                            <FaTrash
                                                className="cursor-pointer"
                                                size={16}
                                                style={{color:'red',marginRight:'5px'}}
                                                onClick={() => handleDelete(card.id)}
                                                title="Delete"
                                            />
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="widget-49 pt-3">
                                            <img
                                                style={{width:'100%',height:'100%'}}
                                                src={process.env.REACT_APP_API_URL+card.src}
                                                alt={card.name}
                                                className="card-img-top"
                                                onClick={() => handleImageClick(process.env.REACT_APP_API_URL+card.src)}
                                            />
                                            <ul className="widget-49-meeting-points mt-2">
                                                <>
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className="row alert alert-danger text-center">
                        <div className="col-lg-12">

                            <h5>{t("Certifications.no_certifications_found")}</h5>
                        </div>
                    </div>

                    }
                </div>



                {/* Pagination */}
                {certifications.length > 0 && <div className="pagination-controls mt-5">
                    <button
                        className="btn btn-warning btn-sm text-white"
                        onClick={() => setPageNo(1)}
                        disabled={pageNo ===0}

                    >
                        {"<<"}
                    </button>{" "}
                    <button
                        className="btn btn-warning btn-sm text-white"
                        onClick={() => setPageNo((prev) => Math.max(prev - 1,0))}
                        disabled={pageNo === 0}
                    >
                        {"<"}
                    </button>{" "}
                    <button
                        className="btn btn-warning btn-sm text-white"
                        onClick={() =>
                            setPageNo((prev) =>
                                Math.min(
                                    prev + 1,
                                    totalPages-1
                                )
                            )
                        }
                        disabled={
                            pageNo >= totalPages-1 
                        }
                    >
                        {">"}
                    </button>{" "}
                    <button
                        className="btn btn-warning btn-sm text-white"
                        onClick={() =>
                            setPageNo(
                                totalPages-1 
                            )
                        }
                        disabled={
                            pageNo >= totalPages-1 
                        }
                    >
                        {">>"}
                    </button>{" "}
                    <span>
                        {t("Governance_Page.page")}
                        {pageNo+1} {t("Governance_Page.to")} {totalPages}
                    </span>
                </div>}
            </div>
                      
            <Modal isOpen={showModal} toggle={handleClose}>
              
                <div className="modal-body">
                    <ModalHeader toggle={handleClose} style={{ direction: "ltr", paddingRight: "10px" }}>
                        {t("Certifications.create_Certification")}
                    </ModalHeader>
                    <ModalBody>
                        <label style={{ color: 'grey' }}>{t('Certifications.label')}</label>
                        <Input
                            type="text"
                            placeholder={t("Certifications.label")}
                            onChange={handleInputChange}
                            className="mb-3"
                        />

                        <div className="mt-3 d-flex flex-wrap">
                            {uploadedFile && (
                                <div key={"file-0"} className="d-flex align-items-center mb-2 position-relative">
                                    <a href={URL.createObjectURL(uploadedFile)} target="_blank" rel="noopener noreferrer">
                                        <FiFile id={"tooltip-file-0"} color="orange" size={40} className="mr-2 cursor-pointer" title={uploadedFile.name} />
                                    </a>
                                    <Tooltip title={uploadedFile.name} target={"tooltip-file-0"} />
                                </div>
                            )}
                        </div>

                        <Input
                            type="file"
                            onChange={handleFileUpload}
                            className="mb-2 mt-3"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn-success-app rounded" onClick={handleSubmit}>
                            {t("Certifications.save")}
                        </button>{' '}
                        <button className="btn-default-app rounded" onClick={handleClose}>
                            {t("Certifications.cancel")}
                        </button>
                    </ModalFooter>
                </div>
            </Modal>
           
            {/* Delete Confirmation Modal */}
            <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)}>
                
                <ModalHeader toggle={() => setShowDeleteModal(false)} style={{ direction: "ltr", paddingRight: "10px" }}>
                {t("Certifications.confirm_delete")}
                    </ModalHeader>

                
                <ModalBody>
                    {t("Certifications.confirm_delete_message")}
                </ModalBody>
                

                <ModalFooter>
                        <button className="btn-success-app rounded" onClick={confirmDelete}>
                            {t("Certifications.save")}
                        </button>{' '}
                        <button className="btn-default-app rounded"  onClick={() => setShowDeleteModal(false)}>
                            {t("Certifications.cancel")}
                        </button>
                    </ModalFooter>
            </Modal>

            {/* Update Modal */}
            <Modal isOpen={showUpdateModal} toggle={() => setShowUpdateModal(false)}>
                <ModalHeader  isOpen={showUpdateModal} toggle={() => setShowUpdateModal(false)} style={{ direction: "ltr", paddingRight: "10px" }}>
                        {t("Certifications.update_Certification")}
                </ModalHeader>
                <ModalBody>
                    <label style={{ color: 'grey' }}>{t('Certifications.label')}</label>
                    <Input
                        type="text"
                        defaultValue={selectedCertification?.name || ''}
                        onChange={handleInputChange}
                         className="mb-3"
                    />
                    <Input
                        type="file"
                        onChange={(e) => {
                            const files = e.target.files;
                            if (files && files.length > 0) {
                                // Update the file in the state
                                setUploadedFile(files[0]);
                            }
                        }}
                        className="mb-2 mt-3"
                    />
                </ModalBody>
                <ModalFooter>
                    <button className="btn-success-app rounded" onClick={confirmUpdate}>
                        {t("Certifications.save")}
                    </button>{' '}
                    <button className="btn-default-app rounded" onClick={() => setShowUpdateModal(false)}>
                        {t("Certifications.cancel")}
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
}
